var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"set-content"},[_c('div',{staticClass:"o-title"},[_vm._v("用户界面设计素材下载")]),_c('el-button',{staticClass:"button-w-b",staticStyle:{"width":"100%"},attrs:{"icon":"el-icon-download","size":"large"},on:{"click":function($event){return _vm.download(_vm.material)}}},[_vm._v("立即下载")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }